import type { RouteRecordRaw } from "vue-router";
import { crudRoutes } from "./helpers/crudRoutes";

// Auth-only routes — inside the auth shell (requiresAuth inherited from parent)
export const manageDataRoutes: RouteRecordRaw[] = [
  ...crudRoutes({
    path: "observations",
    listComponent: () =>
      import("@/views/ManageData/Observations/Observations.vue"),
    formComponent: () =>
      import("@/views/ManageData/Observations/ObservationForm.vue"),
  }),
  ...crudRoutes({
    path: "references",
    listComponent: () => import("@/views/ManageData/References/References.vue"),
    formComponent: () =>
      import("@/views/ManageData/References/ReferenceForm.vue"),
  }),
  ...crudRoutes({
    path: "shariyah-companies",
    listComponent: () =>
      import("@/views/ManageData/ShariyahCompanies/ShariyahCompanies.vue"),
    formComponent: () =>
      import("@/views/ManageData/ShariyahCompanies/ShariyahCompanyForm.vue"),
  }),
  ...crudRoutes({
    path: "departments",
    listComponent: () =>
      import("@/views/ManageData/Departments/Departments.vue"),
    formComponent: () =>
      import("@/views/ManageData/Departments/DepartmentForm.vue"),
  }),
  ...crudRoutes({
    path: "scholars",
    listComponent: () => import("@/views/ManageData/Scholars/Scholars.vue"),
    formComponent: () => import("@/views/ManageData/Scholars/ScholarForm.vue"),
  }),
  ...crudRoutes({
    path: "sectors",
    listComponent: () => import("@/views/ManageData/Sectors/Sectors.vue"),
    formComponent: () => import("@/views/ManageData/Sectors/SectorForm.vue"),
  }),
  ...crudRoutes({
    path: "guidelines",
    listComponent: () => import("@/views/ManageData/Guidelines/Guidelines.vue"),
    formComponent: () =>
      import("@/views/ManageData/Guidelines/GuidelineForm.vue"),
  }),
  ...crudRoutes({
    path: "product-classifications",
    listComponent: () =>
      import("@/views/ManageData/ProductClassifications/ProductClassifications.vue"),
    formComponent: () =>
      import("@/views/ManageData/ProductClassifications/ProductClassificationForm.vue"),
  }),
  ...crudRoutes({
    path: "product-types",
    listComponent: () =>
      import("@/views/ManageData/ProductTypes/ProductTypes.vue"),
    formComponent: () =>
      import("@/views/ManageData/ProductTypes/ProductTypeForm.vue"),
  }),
  ...crudRoutes({
    path: "product-documents",
    listComponent: () =>
      import("@/views/ManageData/ProductDocuments/ProductDocuments.vue"),
    formComponent: () =>
      import("@/views/ManageData/ProductDocuments/ProductDocumentForm.vue"),
  }),
];
